import { AllLeaguesScreenContent } from '@/components/league-navigator/screens/AllLeaguesScreen';

import { useAllLeaguesScreen } from '../hooks/use-all-leagues-screen';

export const SbkAllLeaguesScreen = () => {
    const { sections, status, onSelectLeague, onRetry } = useAllLeaguesScreen();
    return (
        <AllLeaguesScreenContent
            sections={sections}
            status={status}
            onSelectLeague={onSelectLeague}
            onRetry={onRetry}
        />
    );
};
